import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class CategoryService extends CommonService {
  async getCategories(params: _object) {
    return await this.get(`/categories/?${params}`)
  }

  async UpdateCategory(id: string | undefined, params: { [key: string]: boolean }) {
    return await this.put(`/categories/${id}`, params)
  }

  async createCategory(params: { [key: string]: any }) {
    return await this.post('/categories', params)
  }

  async CategoryDetails(id: string | undefined) {
    return await this.get(`/categories/${id}`)
  }

  async DeleteCategory(id: string | undefined) {
    return await this.delete(`/categories/${id}`)
  }
}

export const categoryService = new CategoryService()
